import axios from 'axios';

export default {
  anonymous_auth(token){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/auth/login", {token})
  },
  auth(creds){
    console.log(' AUTH');
			return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/auth/login", creds)
  },
  validateToken(token){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/auth/tokens/"+token+"/validate")
  },
  resetPassword(token, password){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/auth/reset-password", {token, password})
  },
  sendRecoveryPasswordEmail(email){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/auth/forgotPassword", {email})
  },
  refresh(refreshToken){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/auth/refresh", {token : refreshToken})
  },
  createUser(user){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/users", user);
  },
  updateUserV2(userId, user){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/users/" + userId, user)
      .then((response) => response.data);
  },
  updateUser(userArray){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/users", userArray);
  },
  archiveUser(userId){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/users/"+userId);
  },
  listAdminUser(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/users")
      .then(response => response.data)
  },
  listAdminUserV2(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/users?isAdmin=true")
      .then(response => response.data)
  },
  createPortausContextByExternalToken(token) {
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/tokens/soft-portaus-context", { token })
    .then(response => response.data)
  },
  me(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/users/me")
      .then(response => response.data)
  }
}
